import { Flex, Divider, Typography } from "antd";
import { CryptoIcon } from "ui";
import { formatWithDecimals } from "utils";
import { BidEntity } from "interfaces";

interface FirstColumnBlockProps {
  bid: BidEntity;
}

export const AmountBlock = ({ bid }: FirstColumnBlockProps) => {
  const { amount, currency, quote, amountRub } = bid;

  if (!amount) {
    return null;
  }

  return (
    <Flex vertical align="center" gap="small" className="full-width">
      <Flex align="center" justify="space-between" className="full-width">
        <Flex flex={1}>
          <Flex vertical gap="6px">
            <Typography.Text type="secondary" className="text-middle">
              Цифровая валюта
            </Typography.Text>
            <Flex>
              <Typography.Text strong className="text-middle">
                {formatWithDecimals(amount)} {currency}
              </Typography.Text>
              {quote && (
                <Typography.Text
                  type="secondary"
                  className="text-middle"
                >{`${String.fromCharCode(8201)}=${String.fromCharCode(8201)}${formatWithDecimals(amountRub)}${String.fromCharCode(8201)}RUB`}</Typography.Text>
              )}
            </Flex>
          </Flex>
        </Flex>
        <CryptoIcon currency={currency || ""} squareBg size="2xl" squareSize="4xl" />
      </Flex>
      <Divider className="margin-top-sm margin-bottom-sm" />
    </Flex>
  );
};
